<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalDrainage from "../DesignerQuestionTechnicalDrainage.vue";
    import Question from "../mixin/Question.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalDrainage,
            Question
        ],
        props: {
            title: {
                default() {
                    return '';
                }
            },
            maintitle: {
                default() {
                    return 'Drainage';
                }
            },
        },
        computed: {
            panel_required(){
                return true;
            },
        },
    }
</script>
